import type { ReactNode } from 'react'

export type SectionTone = 'paper' | 'surface' | 'forest'

const TONES: Record<SectionTone, string> = {
  paper: '',
  surface: 'bg-vc2-surface',
  forest: 'bg-vc2-forest text-vc2-on-forest',
}

/**
 * One band of a page: a full-bleed `<section>` in one of the three tones with
 * the site container and the standard vertical rhythm inside. `className`
 * lands on the `<section>` (the band), not on the container.
 *
 * No pinned cinema-bar variant here (spec §6: not ported) — always a plain band.
 */
export function Section({
  id,
  tone = 'paper',
  className = '',
  children,
}: {
  id?: string
  tone?: SectionTone
  className?: string
  children: ReactNode
}) {
  return (
    <section id={id} className={`${TONES[tone]} ${className}`.trim() || undefined}>
      <div className="vc2-container py-20 md:py-28">{children}</div>
    </section>
  )
}
